import {
  Component,
  Input,
  AfterViewInit,
  ElementRef,
  ViewChild,
  Output,
  EventEmitter,
  HostBinding,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { Theme } from 'studio-components';
import { provideValueAccessor } from 'studio-components/shared/value-accessor.utils';

@Component({
  selector: 'studio-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss'],
  providers: [provideValueAccessor(() => FormInputComponent)],
})
export class FormInputComponent implements ControlValueAccessor, OnChanges, AfterViewInit {
  @ViewChild('input', { static: false }) inputElement: ElementRef;

  @HostBinding('class')
  @Input()
  public theme: Theme = 'light';

  @Input() public uniqueId: string;
  @Input() public variant: 'variantDefault' | 'white' = 'variantDefault';
  @Input() public autocomplete: HTMLInputElement['autocomplete'] = 'off';
  @Input() public placeholder = '';
  @Input() public editButtonText = 'Edit';
  @Input() public type = 'text';
  @Input() public initFocus = false;
  @Input() public disabled = false;
  @Input() public inlineEdit = false;
  @Input() public isValid = false;
  @Input() public formControlName;
  @Input() value: string;

  @Output() valueSaved = new EventEmitter();
  @Output() focusChanged = new EventEmitter<boolean>(false);

  private initialValue = '';
  public isEditable = true;

  ngOnChanges({ inlineEdit }: SimpleChanges) {
    if (inlineEdit) {
      this.isEditable = !inlineEdit.currentValue;
    }
  }

  ngAfterViewInit() {
    if (this.initFocus) {
      this.inputElement.nativeElement.focus({ preventScroll: true });
    }
  }

  public edit() {
    this.initialValue = this.inputElement.nativeElement.value;
    this.isEditable = true;
  }

  public save() {
    this.disableInput();
    this.valueSaved.emit(this.inputElement.nativeElement.value);
  }

  public cancel() {
    this.inputElement.nativeElement.value = this.initialValue;
    this.onChange(this.initialValue);

    this.disableInput();
  }

  private disableInput() {
    this.initialValue = '';
    this.isEditable = false;
  }

  protected focused() {
    this.focusChanged.next(true);
  }

  protected blurred() {
    this.focusChanged.next(false);
    this.onTouch();
  }

  // Reactive form controls

  public writeValue(value: string) {
    this.value = value;
  }

  public onChange: any = () => {};
  public onTouch: any = () => {};

  public registerOnChange(fn): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn): void {
    this.onTouch = fn;
  }

  // set disabled state
  public setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }
}
